var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path10, _path11, _path12, _g3, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9 39.7l7.3 7.6l-32.1 16.1s-4.2 2.1-6.2-1.2c-8-13 31-22.5 31-22.5",
    fill: "#256382"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 53.9s-6.1 2.3-5 6.6c1.2 4.5 6.1 1.8 6.1 1.8l30.5-15s-1.7-4.8 1.4-8l-33 14.6",
    fill: "#d9e3e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#42ade2",
    d: "M34.4 8.9L63.6 39L29.1 53.3L7 16.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#94989b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.7 42.6l-20.4 8.8l20-9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4 45.2l-21.7 9.5L60 44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6 46.7L32.9 59.4l27.3-13.6z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 62.1c-3.4-7.5 5.3-8.8 5.3-8.8L7 16.7s-5-.1-5 5.4c0 2.3 1 4 1 4l20.8 36",
    fill: "#428bc1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 32.2l-7.3 7.6l32.1 16.1s4.2 2.1 6.2-1.2c8-13-31-22.5-31-22.5",
    fill: "#547725"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3 46.4s6.1 2.3 5 6.6c-1.2 4.5-6 1.8-6 1.8l-30.5-15s1.7-4.8-1.4-8l32.9 14.6",
    fill: "#d9e3e8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#83bf4f",
    d: "M29.2 1.4L0 31.5l34.5 14.3L56.6 9.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#94989b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2 34.2l20 9.7l-20.4-8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6 36.8l21.2 10.4l-21.7-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4 38.3l27.2 13.6L2.9 39.2z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8 54.6c3.4-7.5-5.3-8.8-5.3-8.8L56.6 9.2s5-.1 5 5.4c0 2.3-1 4-1 4l-20.8 36",
    fill: "#699635"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7 26l6.1 6.4l-27.1 13.5s-3.6 1.7-5.3-1C23.8 34 56.7 26 56.7 26z",
    fill: "#962c2c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35 38s-5.2 1.9-4.2 5.6c1 3.8 5.1 1.5 5.1 1.5l25.7-12.7s-1.4-4 1.2-6.7L35 38z",
    fill: "#d9e3e8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c5c",
    d: "M39.4 0L64 25.4L34.9 37.5L16.2 6.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M40.1 5.8l4.8 5.3l-17.7 6.7L23 11z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#94989b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6 28.5l-17.2 7.3l16.8-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4 30.7L43 38.6l18-8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6 31.9L38.2 42.6L61.1 31z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 44.9c-2.8-6.3 4.5-7.4 4.5-7.4L16.2 6.6s-4.3-.1-4.3 4.5c0 1.9.8 3.4.8 3.4l17.8 30.4",
    fill: "#c94747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.d1068df3f0ff693fde5563ab2ed50a81.svg";
export { ForwardRef as ReactComponent };